// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex-container-wrap[data-v-b82ad09c]{justify-content:left !important}", ""]);
// Exports
module.exports = exports;
